angular.module('webtrader').service('Trades', function($http, $q, $rootScope, $interval, $document, Account, BaseTrade, Trade, TradeOption, Feed, Notification) {
  this.init = () => {
    this.initialized = true;
    this.summary = {};
    this.currentClass = Account.info.group.is_options? TradeOption : Trade;
    this.modalOpened = false;
    this.hoverTypeTrade = false;

    Feed.stream.on('trade:remove', this.removeTrade.bind(this));
    Feed.stream.on('trade:result', this.updateTrade.bind(this));
    Feed.stream.on('trade:update', this.updateTrade.bind(this));
    Feed.stream.on('quote', this.onQuoteUpdate.bind(this));

    Feed.stream.on('connected', this.reloadTrades.bind(this));
    this.orderTrades().then(this.reloadTrades.bind(this));
    return this.reloadSummary();
  };

  this.deinit = () => {
    this.initialized = false
  }

  this.orderTrades = () => {
    return $http.post(`${Account.BASE_URL}/trade/order_feed/`).then((res) => {
      Feed.stream.redeemTradesTicket(res.data.ticket)
    })
  }

  this.order = (data) => {
    this.orderStatus = 'loading'
    this.orderErrors = null
    this.orderCmd = data.cmd;
    let order_execute = () => {
      let q = $http.post(`${Account.BASE_URL}/trade/order/`, data)
      q.finally(() => {
        this.orderStatus = null
        this.orderCmd = null;
      })
      q.then((res) => {
        if (res.data.action == "open_modal_registrations"){
          a = $("<a class='hide' data-reveal-form href='" + '/my/accounts/register' + "'></a>");
          $("body").append(a);
          a.click();
        }
        else {
          this.orderStatus = 'success';
          Notification.success(gettext('Trade is open') + ', ' + data.symbol.replace(/_OP$/, '') + ', ' + Account.info.currency.symbol + data.volume);
        }
      })
      q.catch((res) => {
        this.orderErrors = res.data;
        this.orderStatus = 'error';
        Notification.error(gettext("Please change trade's length or amount and retry later"));
      })
      return q
    }

    if (Account.isGuest) {
      Account.DemoAccountCreation().then(order_execute).then(() => {location.href = `/my/webtrader/${Account.currentLogin}`})
    }
    else{
        order_execute()
    }

  }
  this.isReloadSummary = false;
  this.isReloadTrades = false;
  this.reloadTrades = () => {
    if (this.isReloadTrades) {
      return;
    }
      this.isReloadTrades = true;
    if (!this.initialized)
      return
    return $http.get(`${Account.BASE_URL}/trade/`).then((res) => {
      this.objects = res.data.map((data) => new this.currentClass(data))
      this.mapping = {}
      for (let trade of this.objects) {
        this.mapping[trade.ticket] = trade
      }
        this.isReloadTrades = false;
      this.recalculateSummary()
      this.reloadSummary()
    })
  }

  this.updateTrade = (data) => {
    if (this.mapping[data.ticket])
      this.mapping[data.ticket].update(data)
    else {
      let newTrade = new this.currentClass(data)
      this.mapping[newTrade.ticket] = newTrade
      this.objects.push(newTrade)
    }
    this.recalculateSummary()
    this.reloadSummary()
  }

  this.removeTrade = (data) => {
    if (!this.mapping[data.ticket])
      return
    let trade = this.mapping[data.ticket]
    delete this.mapping[trade.ticket]
    this.objects = _.without(this.objects, trade)
    this.recalculateSummary()
    this.reloadSummary()
  }

  this.reloadSummary = () => {
    if (this.isReloadSummary) {
      return;
    }
    this.isReloadSummary = true;

    if (!this.initialized)
      return
    return $http.get(`${Account.BASE_URL}/summary/`).then((res) => {
      this.isReloadSummary = false;
      this.summary = res.data
      this.recalculateSummary()
      $rootScope.$broadcast("trades:summary", res.data)
    })
  }

  $interval(() => {
    if (Account.currentLogin)
      this.reloadSummary()
  }, 20000)

  this.recalculateSummary = () => {
    if (!this.initialized)
      return
    this.summary.opened_profit  = _(this.objects)
      .filter({isOpen: true})
      .map((t) => t.profit + t.swaps + t.commission + t.commission_agent)
      .sum()
    this.summary.equity = this.summary.balance + this.summary.opened_profit + this.summary.credit
    this.summary.margin_free = this.summary.equity - this.summary.margin
    this.summary.margin_level = this.summary.equity * 100 / this.summary.margin
  }

  this.onQuoteUpdate = (symbol, data) => {
    let affected = _(this.objects).filter({isOpen: true, symbol: symbol}).value()
    if (affected.length > 0) {
      for (let trade of affected) {
        trade.close_price = trade.marketPrice
        trade.recalculateProfit()
      }
      this.recalculateSummary()
    }
  }

  this.closeOrder = (orderTicket) => {
    return $http.delete(`${Account.BASE_URL}/trade/${orderTicket}/`).catch((e) => {
      alert('oops');
      throw e;
    });
  }
});


// https://grandcapital.ru/my/webtrader/api/account/10020386/trade/70048344/